import React, { FC } from 'react'

import Typography from '@mui/material/Typography'

import { Alert } from '@app/types/alert'
import { AppIcon } from '@app/components/AppIcon'
import { useBpAlert } from '@app/hooks/useBpAlert'

import AppAlertBase from '../../../../../../../components/AppAlertBase'
import AlertEventTime from '../../../../../../../components/AlertEventTime'

interface SidebarBPAlertProps {
	readonly alert: Alert
}

const SidebarBPAlert: FC<SidebarBPAlertProps> = ({
	alert,
}: SidebarBPAlertProps) => {
	const { iconType, eventTypeBPData, eventTime } = useBpAlert(alert)

	return (
		<>
			<AppAlertBase
				iconSlot={<AppIcon type={iconType} width={30} height={34} />}
				iconBoxSx={{ bgcolor: eventTypeBPData?.light, height: 'auto' }}
				title={alert.data?.alert_description}
				subTitle={
					<Typography fontFamily={'Gilroy-SemiBold, sans-serif'}>
						{alert.headers.last_bp_measure_systolic}/
						{alert.headers.last_bp_measure_diastolic}
						<Typography variant={'caption'} ml={1}>
							mmHg
						</Typography>
					</Typography>
				}
			/>

			<AlertEventTime eventTime={eventTime} />
		</>
	)
}

export default SidebarBPAlert
